import { Box, Flex } from '@chakra-ui/react';
import { setAuthToken } from 'api/helpers';
import AuthService from 'api/services/AuthService';
import InputMy from 'components/InputMy';
import PasswordStrength from 'components/PasswordStrength';
import AuthButton from 'components/singIn/AuthButton';
import Subtitle from 'components/singIn/Subtitle';
import Title from 'components/singIn/Title';
import { useFormik } from 'formik';
import DefaultAuth from 'layouts/auth/Default';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { MAIN_URL } from 'routes';
import { createNewUserValidationSchema } from 'validations';

const initialValues = {
    firstName: '',
    lastName: '',
    password: '',
};

const Invited = () => {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues,
        validationSchema: createNewUserValidationSchema,
        onSubmit: async data => {
            try {
                setLoading(true);
                await AuthService.activate({ ...data, token: params.get('token') })
                    .then(response => {
                        console.log('response', response);
                        setAuthToken(response.data.token);
                        navigate(MAIN_URL);
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            } catch (e) {
                return false;
            }
        },
    });

    return (
        <DefaultAuth>
            <>
                <Title>You're almost there!</Title>
                <Subtitle>Fill in the inputs to finish your registration</Subtitle>
                <Flex flexWrap="wrap" rowGap="24px" columnGap="16px">
                    <Box flex={{ sm: '1 0 100%', lg: '1 0 calc(50% - 16px / 2)' }}>
                        <InputMy
                            required
                            name="firstName"
                            label="First Name"
                            type={'text'}
                            placeholder="First Name"
                            value={formik.values.firstName}
                            onChange={formik.handleChange}
                            error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                            helperText={formik.touched.firstName && formik.errors.firstName}
                            autoComplete="new-password"
                        />
                    </Box>
                    <Box flex={{ sm: '1 0 100%', lg: '1 0 calc(50% - 16px / 2)' }}>
                        <InputMy
                            required
                            name="lastName"
                            label="Last Name"
                            type={'text'}
                            placeholder="Last Name"
                            value={formik.values.lastName}
                            onChange={formik.handleChange}
                            error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                            helperText={formik.touched.lastName && formik.errors.lastName}
                            onBlur={formik.handleBlur}
                            autoComplete="new-password"
                        />
                    </Box>
                    <Box flex="1 0 100%">
                        <InputMy
                            required
                            name="password"
                            label="Password"
                            type={'password'}
                            placeholder="Password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            error={formik.touched.password && Boolean(formik.errors.password)}
                            helperText={formik.touched.password && formik.errors.password}
                            onBlur={formik.handleBlur}
                            autoComplete="new-password"
                            sx={{ mb: '16px' }}
                        />
                        <PasswordStrength password={formik.values.password} />
                    </Box>
                </Flex>

                <AuthButton loading={loading} onClick={formik.submitForm}>
                    Create an Account
                </AuthButton>
            </>
        </DefaultAuth>
    );
};

export default Invited;
